class DeferredMedia extends Theme.Component {

  connectedCallback() {
    this.defineElements({
      poster: '[id^="Deferred-Poster-"]'
    });

    this.addEvent("click", this.elements.poster, this.loadContent);
  }

  loadContent(focus = true) {
    this.pauseAllVideos();

    if (this.getAttribute("loaded")) {
      return;
    }

    const content = document.createElement("div");

    content.appendChild(
      this.querySelector("template").content.firstElementChild.cloneNode(true)
    );

    this.setAttribute("loaded", true);

    const deferredElement = content.querySelector("video, iframe");

    if (deferredElement.dataset.src) {
      deferredElement.src = deferredElement.dataset.src;
    }

    this.appendChild(deferredElement);

    if (focus) {
      deferredElement.focus();
    }
  }

  pauseAllVideos() {
    document.querySelectorAll(".js-youtube").forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
    });

    document.querySelectorAll(".js-vimeo").forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });

    document.querySelectorAll("video").forEach((video) => video.pause());
  }
}

customElements.define("deferred-media", DeferredMedia);
